import { Component, Inject, OnInit } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { Gruppe } from '../../../../../../projects/kiene-core/src/lib/components/gruppen/classes/gruppe';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { KieneBackendApiService } from '../../../../../../projects/kiene-core/src/lib/services/backend-api/kiene-backend-api.service';
import { API_BASE_URL_SERVICE } from '../../../../../../projects/kiene-core/src/lib/kiene-core.config';
import { MessageService } from '../../../../../../projects/kiene-core/src/lib/services/message-service/message.service';
import { Client } from '../../../../../../projects/kiene-core/src/lib/components/client/classes/client';
import { GruppeAuswaehlenDialogInput2 } from './gruppe-auswaehlen-dialog';
import { GruppeAnlegenDialogComponent } from '../../../../../../projects/kiene-core/src/lib/components/gruppen/gruppe-anlegen-dialog/gruppe-anlegen-dialog.component';
import { GruppeAnlegenDialogInput } from '../../../../../../projects/kiene-core/src/lib/components/gruppen/gruppe-anlegen-dialog/gruppe-anlegen-dialog';

@Component({
    selector: 'kiene-gruppe-auswaehlen-dialog',
    templateUrl: './gruppe-auswaehlen-dialog.component.html',
    styleUrls: ['./gruppe-auswaehlen-dialog.component.scss'],
})
export class GruppeAuswaehlenDialogComponent implements OnInit {
    isLoading = false;
    client: Client;
    ladeGruppenSub: Subscription;
    gruppen: Gruppe[] = [];
    searchQuery = '';

    constructor(
        public dialogRef: MatDialogRef<GruppeAuswaehlenDialogComponent>,
        @Inject(MAT_DIALOG_DATA) private data: GruppeAuswaehlenDialogInput2,
        private api: KieneBackendApiService,
        @Inject(API_BASE_URL_SERVICE) private apiBaseUrl: string,
        private messageService: MessageService,
        private dialog: MatDialog,
    ) {
        this.client = this.data?.client;
    }

    ngOnInit(): void {
        this.ladeGruppen();
    }

    ladeGruppen() {
        this.isLoading = true;
        let params = new HttpParams();

        if (this.client) {
            params = params.set('kunde_id', this.client.kunde_id?.toString());
        }

        this.ladeGruppenSub?.unsubscribe();
        params = params.set('standard', '0');
        this.ladeGruppenSub = this.api.getAll(this.apiBaseUrl + 'gruppe/read_akt_kundenportal.php', params).subscribe({
            next: response => {
                this.isLoading = false;
                this.gruppen = response.records;
            },
            error: err => {
                this.isLoading = false;
                this.messageService.errorMessage('Fehler beim Laden der Gruppen!', err);
            },
        });
    }

    hinzufuegen(gruppe: Gruppe) {
        this.dialogRef.close(gruppe);
    }

    getGruppeMeta(gruppe: Gruppe): string {
        const parts: string[] = [];
        if (gruppe?.stall) {
            parts.push(`Stall: ${gruppe.stall}`);
        }
        if (gruppe?.abteil) {
            parts.push(`Abteil: ${gruppe.abteil}`);
        }
        return parts.join(' · ');
    }

    get filteredGruppen(): Gruppe[] {
        const query = this.searchQuery?.trim().toLowerCase();
        if (!query) {
            return this.gruppen ?? [];
        }

        return (this.gruppen ?? []).filter(g => {
            const bezeichnung = g?.bezeichnung?.toLowerCase() ?? '';
            const stall = g?.stall?.toLowerCase() ?? '';
            const kunde = g?.kunde?.toLowerCase() ?? '';
            const zusatz = g?.zusatz?.toLowerCase() ?? '';
            const anzahlTiere = (g?.anzahl_tiere_aktuell ?? '').toString().toLowerCase();
            return (
                bezeichnung.includes(query) ||
                stall.includes(query) ||
                kunde.includes(query) ||
                zusatz.includes(query) ||
                anzahlTiere.includes(query)
            );
        });
    }

    close() {
        this.dialogRef.close();
    }

    neueGruppeAnlegen(): void {
        if (!this.client) {
            return;
        }

        const input = new GruppeAnlegenDialogInput(this.client, true, '', null);
        this.dialog
            .open<GruppeAnlegenDialogComponent, GruppeAnlegenDialogInput, Gruppe>(GruppeAnlegenDialogComponent, {
                maxWidth: '95vw',
                maxHeight: '90vh',
                width: '560px',
                data: input,
            })
            .afterClosed()
            .subscribe({
                next: gruppe => {
                    if (!gruppe) {
                        return;
                    }
                    this.dialogRef.close(gruppe);
                },
            });
    }
}
